import type { ApiGetSupportedEntitiesVariables } from '@repo/api-codegen';
import { fetchApiGetSupportedEntities, useApiContext } from '@repo/api-codegen';
import { keepPreviousData, useInfiniteQuery } from '@tanstack/react-query';
import { isNil } from 'lodash-es';

const useInfiniteApiGetSupportedEntities = (
	variables: Omit<ApiGetSupportedEntitiesVariables, 'page'>,
	options?: { refetchOnMount?: boolean }
) => {
	const { fetcherOptions, queryKeyFn } = useApiContext();
	return useInfiniteQuery({
		queryKey: queryKeyFn({
			path: '/monitor/recommend/supported_entities/',
			operationId: 'apiGetSupportedEntities',
			variables,
		}),
		placeholderData: keepPreviousData,
		queryFn: ({ pageParam = 1 }) =>
			fetchApiGetSupportedEntities({
				...fetcherOptions,
				...{
					...variables,
					queryParams: {
						...variables.queryParams,
						page: pageParam,
					},
				},
			}),
		initialPageParam: 1,
		getPreviousPageParam: (firstPage) =>
			isNil(firstPage.meta.previous_page) ? null : firstPage.meta.previous_page,
		getNextPageParam: (lastPage) =>
			isNil(lastPage.meta.next_page) ? null : lastPage.meta.next_page,
		...options,
	});
};

export default useInfiniteApiGetSupportedEntities;
